<template>
  <v-container fluid class="mt-n3">
    <v-card flat class="disable-scrollbars">
      <v-card-text>
        <v-row style="max-height: 20px">
          <v-col
            class="text-center mt-n3"
            cols="12"
            sm="12"
            md="12"
            lg="12"
            xs="12"
          >
            <h1
              class="font-weight-bold m-padd-5"
              style="text-transform: uppercase; font-size: 24px; color:#26A69A"
            >
              <v-badge tile content="Kzs | transação diária" color="green">
                {{ new Intl.NumberFormat("de-DE").format(getBalanceReport) }}
              </v-badge>
            </h1>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapHelperEnterprise } from "@/store/helperEnterprise";

export default {
  name: "DailyAmount",
  data: () => ({}),
  computed: {
    ...mapHelperEnterprise
  }
};
</script>

<style scoped></style>
